import { i18n } from '@/config/i18n'
import { NumberMap, StringMap } from '@/shared/utils/map'
import { LocaleMessageObject } from 'vue-i18n'

export type ErrorTransformerOptions =
  | ((_: Response) => string)
  | string
  | NumberMap<string | StringMap<string> | LocaleMessageObject>

/**
 * Transform an error that was given by the backend. Allows for customisation by giving one of the following:
 *
 * - string: Show the given string
 * - (response) => string: Apply the transformation function and show it's result
 * - NumberMap: A map of [statusCode: number]: string tupels. Try to match the status code and show either
 *   - the message for the status code
 *   - a common message if the status code can't be found
 *
 * @param error
 * @param options
 * @constructor
 */
export function transformError(error: Response, options?: ErrorTransformerOptions): string {
  let message: string = ''

  if (typeof options === 'string') {
    // Return the given message
    message = i18n.t(options) as string
  } else if (options instanceof Function) {
    // Call the transformation function and return the returned message
    message = options(error)
  } else if (error && error.status) {
    // Check if the status code exists and if the property is a StringMap
    if (options && typeof options === 'object' && error.status in options) {
      const value = options[error.status]

      if (typeof value === 'object') {
        // Map the answer of the backend to a string (can be used to map returned errors to a translated message)
        // e.g. when registering: The backend will return a "400 Bad Request" with the reason in the body as a translatable key
        // message = value[error.data] as string
        //
        // if (message === undefined) {
        //   message = i18n.t('common.error.undefined').toString()
        // }
      } else {
        message = i18n.t(value) as string
      }
    } else {
      const params: { errorCode?: string } = {}

      if (error.headers.has('x-response-id') != null) {
        params.errorCode = error.headers.get('x-response-id') ?? undefined
      }

      // Map the status code to translated message of to a generic error
      message =
        status[error.status] ||
        i18n.t(`http.status.${error.status}`, params).toString() ||
        i18n.t('http.status.unknown', params).toString()
    }
  } else {
    // Unknown error occurred
    message = i18n.t('common.error.undefined').toString() || 'Undefinierter Fehler'
  }

  return message
}
